export const sectorList = [
  {
    id: "Transportation",
    name: "Transportation",
  },
  {
    id: "Energy",
    name: "Energy",
  },
  {
    id: "Social Infrastructure",
    name: "Social Infrastructure",
  },
  {
    id: "Utility",
    name: "Utility",
  },
  {
    id: "Built Environment",
    name: "Built Environment",
  },
];

export const countryList = [
  {
    id: "Thailand",
    name: "Thailand",
  },
  {
    id: "Malaysia",
    name: "Malaysia",
  },
  {
    id: "Indonesia",
    name: "Indonesia",
  },
  {
    id: "Singapore",
    name: "Singapore",
  },
  {
    id: "Philippines",
    name: "Philippines",
  },
  {
    id: "Myanmar",
    name: "Myanmar",
  },
  {
    id: "Vietnam",
    name: "Vietnam",
  },
  {
    id: "Cambodia",
    name: "Cambodia",
  },
  {
    id: "Laos",
    name: "Laos",
  },
  {
    id: "Brunei",
    name: "Brunei",
  },
];

export const stageList = [
  {
    id: "Early Stage",
    name: "Early Stage",
  },
  {
    id: "Planning",
    name: "Planning",
  },
  {
    id: "Procurement",
    name: "Procurement",
  },
];

export const subSector: any = {
  Transportation: [
    { id: "Road", name: "Road" },
    { id: "Urban Transportation - Bus", name: "Urban Transportation - Bus" },
    {
      id: "Urban Transportation - Rail",
      name: "Urban Transportation - Rail",
    },
    { id: "Railway", name: "Railway" },
    { id: "Mobility & EV", name: "Mobility & EV" },
    { id: "Logistics", name: "Logistics" },
    { id: "Ports", name: "Ports" },
    { id: "Airports", name: "Airports" },
    { id: "Other", name: "Other" },
  ],
  Energy: [
    { id: "Waste to Energy", name: "Waste to Energy" },
    { id: "Solar", name: "Solar" },
    { id: "Wind", name: "Wind" },
    { id: "Hydropower", name: "Hydropower" },
    { id: "Natural Gas", name: "Natural Gas" },
    { id: "Geothermal", name: "Geothermal" },
  ],
  "Social Infrastructure": [
    { id: "Hospital", name: "Hospital" },
    { id: "School", name: "School" },
    { id: "Affordable Housing", name: "Affordable Housing" },
  ],
  Utility: [
    { id: "Water", name: "Water" },
    { id: "Waste", name: "Waste" },
    { id: "Other", name: "Other" },
  ],
  "Built Environment": [
    { id: "Smart City", name: "Smart City" },
    { id: "Other", name: "Other" },
  ],
};
